var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Dropdown } from '../dropdown';
export class ContextMenu extends React.PureComponent {
    render() {
        const _a = this.props, { children, menu, overlay } = _a, props = __rest(_a, ["children", "menu", "overlay"]);
        return (React.createElement(Dropdown, Object.assign({}, props, { overlay: menu || overlay, trigger: "contextMenu" }), children));
    }
}
//# sourceMappingURL=index.js.map